export const staticComponent = {
  id: 'component',
  schema: {
    type: 'object',
    properties: {},
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'Component',
    uiType: 'component',
    title: '',
    fieldName: 'Component 1',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    elements: [],
    formData: false,
    layoutPadding: '0px',
  },
}
